import React, { useState } from 'react';
import { ModalEditProfile } from './ModalEditProfile';
import { ModalChangePassword } from './ModalChangePassword';
import { ModalInformPassword } from './ModalInformPassword';
import { ModalDeveloperToken } from './ModalDeveloperToken';

type ModalProps = {
  user: any;
  onCancel: () => void;
}

const ModalEditAccount: React.FC<ModalProps> = (props) => {
  const [pageModal, setPageModal] = useState<string>("EditAccount");
  const [emailFieldEnabled, setEmailFieldEnabled] = useState<boolean>(false);
  const [currentPassword, setCurrentPassword] = useState<string>();


  return (
    <>
      {pageModal === "EditAccount" && <ModalEditProfile user={props.user} onCancel={props.onCancel} onChangePage={setPageModal} enableEmailField={emailFieldEnabled} currentPassword={currentPassword} />}
      {pageModal === "ChangePassword" && <ModalChangePassword user={props.user} onCancel={props.onCancel} onChangePage={setPageModal} />}
      {pageModal === "InformPassword" && <ModalInformPassword user={props.user} onCancel={props.onCancel} onChangePage={setPageModal} onChangeEmailFieldEnabled={setEmailFieldEnabled} onPasswordConfirmed={setCurrentPassword} />}
      {pageModal === "DeveloperToken" && <ModalDeveloperToken user={props.user} onCancel={props.onCancel} onChangePage={setPageModal} />}
    </>
  )
}

export default ModalEditAccount;
